module.exports = __webpack_public_path__ + "static/media/71.44f81f44.png";